const itemsData = {
  Id: 1,
  boxLines: [
    {
      rowList: [
        { title: "付款日期: ", banding: "RecDate", value: "", dataType: 'Date' },
        { title: "付款金额: ", banding: "Amount", value: "", className: 'c-amount-color' }
      ]
    },

    {
      rowList: [
        { title: "收款银行:  ", banding: "RecBankName", value: "" }
      ]
    }
  ]
};
export { itemsData };
